namespace Portico.Services {

	import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;

	import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import pmi = Portico.Models.Interfaces;
	import pms = Portico.Models.Setup;
	import ps = Portico.Services;

    export interface IInnerStorageService {
		$default(items: {}): IInnerStorageService;
		$reset(items?: {}): IInnerStorageService;
        $apply(): void;
        $sync(): void;
        get<T>(key: string): T;
    }

	export interface IStorageProvider extends angular.IServiceProvider, IInnerStorageService {
        get<T>(key: string): T;
        set<T>(key: string, value: T): T;

        setKeyPrefix(prefix: string): void;
        setSerializer(serializer: (value: any) => string): void;
        setDeserializer(deserializer: (value: string) => any): void;
    }

    export interface IStorageService {
        getItem: <T>(storageType: pm.StorageType, key: string) => T;
        saveItem: <T>(storageType: pm.StorageType, key: string, value: T) => void;
        deleteItem: <T>(storageType: pm.StorageType, key: string) => void;
    }

    @Service('app', 'storageService')
	@Inject('$localStorage', '$sessionStorage', 'dataService')
    export class StorageService implements IStorageService {
		/* istanbul ignore next */
		constructor(
			private $localStorage: IStorageProvider,
			private $sessionStorage: IStorageProvider,
			private dataService: ps.IDataService
        ) { }

		getItem<T>(storageType: pm.StorageType, key: string): T {
			// skip when in debug or nocache mode (workaround for this.$state.params['app'])
			if (this.dataService.session.mode === 'debug' || this.dataService.session.mode === 'nocache') {
				return null;
			}

            const storageProvider = this.getStorageProvider(storageType);

            return storageProvider.hasOwnProperty(key) ? storageProvider[key] as T : null;
        }

		saveItem<T>(storageType: pm.StorageType, key: string, value: T): void {
			// skip when in debug or nocache mode
			if (this.dataService.session.mode === 'debug' || this.dataService.session.mode === 'nocache') {
				return null;
			}

            const storageProvider = this.getStorageProvider(storageType);

            storageProvider[key] = value;
        }

		deleteItem<T>(storageType: pm.StorageType, key: string): void {
			// skip when in debug or nocache mode
			if (this.dataService.session.mode === 'debug' || this.dataService.session.mode === 'nocache') {
				return null;
			}

            const storageProvider = this.getStorageProvider(storageType);

            if (storageProvider.hasOwnProperty(key)) {
                delete storageProvider[key];
            }
        }

		private getStorageProvider(storageType: pm.StorageType): IStorageProvider {
            switch (storageType) {
				case pm.StorageType.Local:
                    return this.$localStorage;
				case pm.StorageType.Session:
                    return this.$sessionStorage;
                default:
                    return this.$sessionStorage;
            }
        }
    }
}